import { localisedValue } from "utils"

const commonTransformer = data => {
  return data?.map(item => ({
    ...item,
    label: localisedValue({ object: item, key: "name" }) || "-",
    value: item?.id?.toString(),
  }))
}

export default commonTransformer
